import { BusinessStructure, BusinessType } from '@paid-ui/enums/business';

import { OwnerType, RoleInBusiness, RoleInCompany, TrustType } from '../models/enums';

export const businessTypeOptions = [
  {
    value: BusinessType.BUILDER,
    label: "I'm a builder",
  },
  {
    value: BusinessType.OWNER,
    label: "I'm a property owner",
  },
  {
    value: BusinessType.SUBCONTRACTOR,
    label: "I'm a subcontractor",
  },
  {
    value: BusinessType.SUPPLIER,
    label: "I'm a supplier",
  },
  {
    value: BusinessType.SUPERINTENDENT,
    label: "I'm a architect / superintendent",
  },
  {
    value: BusinessType.FUNDER,
    label: "I'm a funder",
  },
  {
    value: BusinessType.QUANTITY_SURVEYOR,
    label: "I'm a Quantity Surveyor",
  },
];

export const businessStructureOptions = [
  {
    color: 'primary',
    label: "It's a company (not a trust)",
    tooltip: 'Do not select this if your company is a trustee company.',
    value: BusinessStructure.COMPANY,
  },
  {
    color: 'primary',
    label: "It's a trust",
    tooltip:
      'Select this if your business is run through a trust structure (e.g. family trust or unit trust), even if a company acts as the trustee.',
    value: BusinessStructure.TRUST,
  },
  {
    color: 'primary',
    label: "It's a partnership",
    tooltip:
      'Select this if your business is jointly owned and operated by two or more people or entities under a partnership agreement.',
    value: BusinessStructure.PARTNERSHIP,
  },
  {
    color: 'primary',
    label: "I'm a sole trader",
    tooltip:
      'Choose this if you run the business as an individual using your own name or a registered business name under an ABN.',
    value: BusinessStructure.SOLE_TRADER,
  },
  {
    color: 'primary',
    label: 'Other',
    tooltip:
      'Choose this if none of the above structures fit. Only the business name is required; ABN and other details are optional.',
    value: BusinessStructure.OTHER,
  },
];

export const roleInBusinessOptions = [
  {
    value: RoleInBusiness.PARTNERSHIP,
    label: "I'm the business owner",
  },
  {
    value: RoleInBusiness.SOLE_TRADER,
    label: "I'm the business owner",
  },
  {
    value: RoleInBusiness.EMPLOYEE,
    label: "I'm an employee",
  },
];

export const roleInCompanyOptions = [
  {
    value: RoleInCompany.SOLE_DIRECTOR,
    label: "I'm the sole Director / Secretory",
    tooltip: "Select this if you're the only director or secretary registered with ASIC.",
  },
  {
    value: RoleInCompany.DIRECTOR,
    label: "I'm one of multiple directors",
    tooltip: 'Select this if your company has multiple directors or secretaries.',
  },
  {
    value: RoleInCompany.EMPLOYEE,
    label: "I'm an employee",
    tooltip:
      'Select this if you work for the company but are not listed as a director or secretary with ASIC.',
  },
];

export const roleInTrusteeCompanyOptions = [
  {
    value: RoleInCompany.SOLE_DIRECTOR,
    label: 'No, my company has a single director',
    tooltip:
      'Select this if you are the only person listed as both the director and secretary of the trustee company on ASIC records.',
  },
  {
    value: RoleInCompany.DIRECTOR,
    label: 'Yes, my company has multiple directors',
    tooltip: 'Select this if you are one of several directors listed for the trustee company.',
  },
];

export const trustTypeOptions = [
  {
    label: "I'm an individual trustee",
    value: TrustType.INDIVIDUAL,
    tooltip:
      'You are personally listed as the trustee in the trust deed and responsible for managing the trust directly.',
  },
  {
    label: "I'm an officer of a trustee company",
    value: TrustType.OFFICER_OF_COMPANY,
    tooltip:
      'You are a director or authorised officer of a company that acts as the trustee for the trust.',
  },
  {
    label: "I'm an employee of a trustee company",
    value: TrustType.EMPLOYEE_OF_COMPANY,
    tooltip:
      "You work for the company that acts as trustee, but you're not listed as a director or officer.",
  },
  {
    label: "I'm an employee of a individual trustee",
    value: TrustType.EMPLOYEE_OF_INDIVIDUALS,
    tooltip:
      "You work for the trust that managed by the individuals, but you're not listed as a director or officer.",
  },
];

export const ownerTypeOptions = [
  {
    label: 'Yes, I have an ABN',
    value: OwnerType.BUSINESS,
  },
  {
    label: "No, I don't have an ABN",
    value: OwnerType.INDIVIDUALS,
  },
];
